import { DataTableColumnHeader } from 'common/data-table-column-header';
import { dateTimeCell, numberCell } from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'type',
    header: 'Type',
  },
  {
    accessorKey: 'begin_operator',
    header: 'Begin Operator',
    meta: {
      className: 'text-right',
    },
  },
  {
    accessorKey: 'begin_volume',
    header: 'Begin Volume',
    meta: {
      className: 'text-right',
    },
    cell: numberCell,
  },
  {
    accessorKey: 'end_operator',
    header: 'End Operator',
    meta: {
      className: 'text-right',
    },
  },
  {
    accessorKey: 'end_volume',
    header: 'End Volume',
    meta: {
      className: 'text-right',
    },
    cell: numberCell,
  },

  {
    accessorKey: 'label',
    header: 'Label',
  },
  {
    accessorKey: 'unit_type',
    header: 'Unit',
  },
  {
    accessorKey: 'value',
    header: 'Value %',
    cell: numberCell,
    meta: {
      className: 'text-right',
    },
  },

  {
    accessorKey: 'fund_product_id',
    header: 'Fund Product Id',
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
];
